import { neon } from "@neondatabase/serverless";

const databaseUrl = process.env.REACT_APP_DATABASE_URL || process.env.REACT_APP_POSTGRES_URL;

if (!databaseUrl) {
  console.error("REACT_APP_DATABASE_URL or REACT_APP_POSTGRES_URL environment variable is not set");
}

export const sql = neon(databaseUrl);